import { Box } from '@mui/material';
import { MarkdownEditorWithPreview } from 'domain/shared/core/input';
import { Button } from 'framework/ui/mui-builder';
import { ShowPageLayout } from 'framework/ui/layout';
import { useNavigate } from 'react-router-dom';
import useComplianceDocumentVersionEditorData from './useComplianceDocumentVersionEditorData';
import UploadMarkdownButton from './UploadMarkdownButton';
import { useDocumentBlob, DocumentPreviewRenderer } from 'domain/shared/documentStorage';
import { COMPLIANCE_MD_EDITOR_FINALIZE_PATH, COMPLIANCE_REGISTRY_PATH } from '../../router';

const ComplianceDocumentVersionEditorPage = () => {
  const navigate = useNavigate();
  const { content, setContent, uploadAndLoadMarkdown, hasChanges, isMarkdownPath, search, documentPathToEdit } =
    useComplianceDocumentVersionEditorData();
  const { blobUrl, loading, hasError } = useDocumentBlob(documentPathToEdit || null);

  const handleEditorChange = (values: Record<string, string>) => {
    const nextValue = values.template ?? Object.values(values)[0] ?? '';
    setContent(nextValue);
  };

  const handleContinue = () => {
    navigate(`${COMPLIANCE_MD_EDITOR_FINALIZE_PATH}${search}`, {
      state: { editedContent: content },
    });
  };
  const handleCancel = () => navigate(COMPLIANCE_REGISTRY_PATH);

  return (
    <ShowPageLayout hasSeparateSections>
      <UploadMarkdownButton onSelectFile={uploadAndLoadMarkdown} />

      {isMarkdownPath ? (
        <Box
          sx={{
            '& .MuiPaper-root > .MuiBox-root': {
              maxHeight: 'none !important',
            },
          }}
        >
          <MarkdownEditorWithPreview
            key={documentPathToEdit || 'compliance-md-editor'}
            source="template"
            value={content}
            onChangeCallback={handleEditorChange}
          />
        </Box>
      ) : (
        <DocumentPreviewRenderer
          documentPath={documentPathToEdit}
          blobUrl={blobUrl}
          loading={loading}
          hasError={hasError}
          defaultScale={0.8}
        />
      )}

      <Box display="flex" justifyContent="flex-end" gap={1}>
        <Button color="primary" onClick={handleContinue} disabled={!hasChanges || !isMarkdownPath}>
          Continue
        </Button>

        <Button color="primary" variant="outlined" onClick={handleCancel}>
          Cancel
        </Button>
      </Box>
    </ShowPageLayout>
  );
};

export default ComplianceDocumentVersionEditorPage;
